import { useMemo, useContext } from "react";
import PropTypes from "prop-types";
import Skeleton from "@mui/material/Skeleton";
import CustomStatusDropdown from "components/CustomDropdown/CustomStatusDropdown";
import { SeverityTypeContext } from "contexts/SeverityTypeContext";

export default function EditableSeverityChip({ severity, setSeverity }) {
  const { loading, error, severityTypes } = useContext(SeverityTypeContext);

  const severityType = useMemo(
    () => severityTypes.find(({ id }) => id === severity),
    [severity, severityTypes]
  );

  const modifiedSeverityTypes = useMemo(
    () =>
      severityTypes.map(severity => ({
        ...severity,
        color: severity.backgroundColor
      })),
    [severityTypes]
  );

  if (loading) return <Skeleton variant="rectangular" height={29} />;

  if (error) return "Severity types not found";

  return (
    <CustomStatusDropdown
      buttonText={severityType?.name}
      caret={false}
      fontSize="small"
      buttonProps={{
        round: true,
        style: {
          backgroundColor: severityType?.backgroundColor,
          color: severityType?.color
        }
      }}
      onClick={param => setSeverity(param?.id)}
      dropdownList={modifiedSeverityTypes}
    />
  );
}

EditableSeverityChip.propTypes = {
  severity: PropTypes.number,
  setSeverity: PropTypes.func
};
